import { store } from 'app/redux/store';
import { BusinessProjectGetId } from 'app/services/responseTypes';
import {
  updateKey,
  updateFieldArrayKey,
  OwnersStateValues,
} from '../edit/TaxQuestionnaire/BusinessInfo/Owners/slice';

export default function autoFillBusinessOwnersSlice(
  business: BusinessProjectGetId,
) {
  const { business_owners } = business;

  store.dispatch(updateKey({ key: 'OwnersList', value: [] }));

  const toFill: OwnersStateValues[] = [];
  business_owners?.forEach((owner) => {
    toFill.push({
      firstName: owner.firstname,
      lastName: owner.lastname,
      OfOwnership: owner.ownership_percentage,
      socialSecurityNumber: owner.ssn,
      address: owner.address,
      city: owner.city,
      state: owner.state,
      zipCode: owner.zipcode,
      country: owner.country,
    });
  });

  store.dispatch(updateFieldArrayKey({ key: 'OwnersList', value: toFill }));
}
